import { ServerOptions } from '@commercetools/frontend-sdk';
import { ComposableCommerceEventsB2B } from '../../types/events/ComposableCommerceEventsB2B';
import { ProductPaginatedResult } from '@shared/types/result';
import { CommercetoolsSdk } from '../Integration';

export type PaymentActions = {
    windcaveCreateSession: any;
    windcaveVerifySession: any;
    payNow: any;
    verifyPayment: any;
};

export const getPaymentActions = (sdk: CommercetoolsSdk<ComposableCommerceEventsB2B>): PaymentActions => {
    return {
        windcaveCreateSession: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'payment/windcaveCreateSession',
                payload: payload,
                serverOptions: options.serverOptions,
            });
            return response;
        },
        windcaveVerifySession: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'payment/windcaveVerifySession',
                payload: payload,
                serverOptions: options.serverOptions,
            });
            return response;
        },

        payNow: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'payment/payNow',
                payload: payload,
                serverOptions: options.serverOptions,
            });
            return response;
        },
        verifyPayment: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'payment/verifyPayment',
                payload: payload,
                serverOptions: options.serverOptions,
            });
            return response;
        },


    };
};
